// import React, { useRef, useState, useEffect } from "react";
// import "./DigitalSignature.css";

// function DigitalSignature({ onSubmit, isSubmitted }) {
//     const canvasRef = useRef(null);
//     const [isDrawing, setIsDrawing] = useState(false);
//     const [hasSignature, setHasSignature] = useState(false);

//     // Initialize and resize canvas
//     useEffect(() => {
//         const canvas = canvasRef.current;
//         if (!canvas) return;

//         const ctx = canvas.getContext("2d");

//         const resizeCanvas = () => {
//             const rect = canvas.getBoundingClientRect();
//             const dpr = window.devicePixelRatio || 1;

//             canvas.width = rect.width * dpr;
//             canvas.height = rect.height * dpr;

//             ctx.scale(dpr, dpr);

//             ctx.fillStyle = "#ffffff";
//             ctx.fillRect(0, 0, rect.width, rect.height);

//             ctx.strokeStyle = "#000000";
//             ctx.lineWidth = 2;
//             ctx.lineCap = "round";
//             ctx.lineJoin = "round";
//         };

//         resizeCanvas();
//         window.addEventListener("resize", resizeCanvas);

//         return () => window.removeEventListener("resize", resizeCanvas);
//     }, []);

//     // Drawing Handlers
//     const handleMouseDown = (e) => {
//         if (isSubmitted) return;

//         const canvas = canvasRef.current;
//         const rect = canvas.getBoundingClientRect();
//         const x = e.clientX - rect.left;
//         const y = e.clientY - rect.top;

//         const ctx = canvas.getContext("2d");
//         ctx.beginPath();
//         ctx.moveTo(x, y);
//         setIsDrawing(true);
//     };

//     // Mouse move handler
//     const handleMouseMove = (e) => {
//         if (!isDrawing || isSubmitted) return;

//         const canvas = canvasRef.current;
//         const rect = canvas.getBoundingClientRect();
//         const x = e.clientX - rect.left;
//         const y = e.clientY - rect.top;

//         const ctx = canvas.getContext("2d");
//         ctx.lineTo(x, y);
//         ctx.stroke();
//         setHasSignature(true);
//     };

//     // Mouse up handler
//     const handleMouseUp = () => {
//         setIsDrawing(false);
//     };

//     // Touch handlers
//     const handleTouchStart = (e) => {
//         if (isSubmitted) return;

//         e.preventDefault();
//         const canvas = canvasRef.current;
//         const touch = e.touches[0];
//         const rect = canvas.getBoundingClientRect();
//         const x = touch.clientX - rect.left;
//         const y = touch.clientY - rect.top;

//         const ctx = canvas.getContext("2d");
//         ctx.beginPath();
//         ctx.moveTo(x, y);
//         setIsDrawing(true);
//     };

//     // Touch move handler
//     const handleTouchMove = (e) => {
//         if (!isDrawing || isSubmitted) return;

//         e.preventDefault();
//         const canvas = canvasRef.current;
//         const touch = e.touches[0];
//         const rect = canvas.getBoundingClientRect();
//         const x = touch.clientX - rect.left;
//         const y = touch.clientY - rect.top;

//         const ctx = canvas.getContext("2d");
//         ctx.lineTo(x, y);
//         ctx.stroke();
//         setHasSignature(true);
//     };

//     // Touch end handler
//     const handleTouchEnd = () => {
//         setIsDrawing(false);
//     };

//     // Clear signature
//     const handleClearSignature = () => {
//         const canvas = canvasRef.current;
//         const ctx = canvas.getContext("2d");
//         ctx.fillStyle = "#ffffff";
//         ctx.fillRect(0, 0, canvas.width, canvas.height);
//         setHasSignature(false);
//     };

//     // Submit signature
//     const handleSubmitSignature = () => {
//         if (!hasSignature) {
//             alert("Please sign before submitting");
//             return;
//         }

//         const canvas = canvasRef.current;
//         const signatureData = canvas.toDataURL("image/png");
//         onSubmit(signatureData);
//     };

//     // Render component
//     return (
//         <div className="digital-signature-container">
//             <div className="signature-box">
//                 <canvas
//                     ref={canvasRef}
//                     width={600}
//                     height={300}
//                     className={`signature-canvas ${isSubmitted ? "submitted" : ""}`}
//                     onMouseDown={handleMouseDown}
//                     onMouseMove={handleMouseMove}
//                     onMouseUp={handleMouseUp}
//                     onMouseLeave={handleMouseUp}
//                     onTouchStart={handleTouchStart}
//                     onTouchMove={handleTouchMove}
//                     onTouchEnd={handleTouchEnd}
//                 />
//             </div>

//             <div className="signature-actions">
//                 <button
//                     className="btn-change-signature rounded-pill"
//                     onClick={handleClearSignature}
//                     disabled={!hasSignature || isSubmitted}
//                 >
//                     Change Signature
//                 </button>
//                 <button
//                     className="btn-submit-signature rounded-pill"
//                     onClick={handleSubmitSignature}
//                     disabled={isSubmitted}
//                 >
//                     {isSubmitted ? "✓ Signature Submitted" : "Submit Signature"}
//                 </button>
//             </div>

//         </div>
//     );
// }

// export default DigitalSignature;

/////////////////////////////////////////////////
// DIGITAL SIGNATURE — Final Flow
// First time: draw → auto-saved on Submit
// Next time: saved signature loads automatically, no drawing needed
// Change: click "Change Signature" → redraw → auto-saved on next Submit

import React, { useRef, useState, useEffect } from "react";
import "./DigitalSignature.css";
import { profileApi } from "../../../api/profileApi";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";

function DigitalSignature({ onChange, isSubmitted }) {
  const canvasRef = useRef(null);
  const hasFetched = useRef(false);

  const [isDrawing, setIsDrawing] = useState(false);
  const [hasDrawn, setHasDrawn] = useState(false);
  const [userSignature, setUserSignature] = useState(null); // saved signature URL
  const [isEditMode, setIsEditMode] = useState(false);      // show canvas or preview
  const [loading, setLoading] = useState(true);

  /* ═══════════════════════════════════════════
     1. FETCH SAVED SIGNATURE ON MOUNT
  ═══════════════════════════════════════════ */
  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const fetchSignature = async () => {
      try {
        setLoading(true);
        const res = await profileApi.getSignature();
        const saved = res?.digitalSignature || null;
        setUserSignature(saved);

        if (saved) {
          // Has saved signature → pass to parent immediately, show preview
          onChange?.(saved);
          setIsEditMode(false);
        } else {
          // No saved signature → show canvas to draw
          setIsEditMode(true);
        }
      } catch (err) {
        // On error, show canvas so user can still draw
        setIsEditMode(true);
      } finally {
        setLoading(false);
      }
    };

    fetchSignature();
  }, []);

  /* ═══════════════════════════════════════════
     2. SETUP CANVAS WHEN EDIT MODE OPENS
  ═══════════════════════════════════════════ */
  useEffect(() => {
    if (!isEditMode) return;

    // Small delay to ensure canvas is mounted in DOM
    const timer = setTimeout(() => {
      const canvas = canvasRef.current;
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      const rect = canvas.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;

      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;

      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.scale(dpr, dpr);

      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, rect.width, rect.height);
      ctx.strokeStyle = "#000000";
      ctx.lineWidth = 2;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
    }, 50);

    return () => clearTimeout(timer);
  }, [isEditMode]);

  /* ═══════════════════════════════════════════
     3. DRAWING HANDLERS
  ═══════════════════════════════════════════ */
  const getCtx = () => canvasRef.current?.getContext("2d");

  const startDrawing = (x, y) => {
    if (isSubmitted) return;
    const ctx = getCtx();
    ctx.beginPath();
    ctx.moveTo(x, y);
    setIsDrawing(true);
  };

  const draw = (x, y) => {
    if (!isDrawing || isSubmitted) return;
    const ctx = getCtx();
    ctx.lineTo(x, y);
    ctx.stroke();
    setHasDrawn(true);
  };

  const stopDrawing = () => {
    if (!isDrawing) return;
    setIsDrawing(false);
    if (hasDrawn) {
      const data = canvasRef.current.toDataURL("image/png");
      onChange?.(data); // pass to parent in real time
    }
  };

  // Mouse
  const handleMouseDown = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    startDrawing(e.clientX - rect.left, e.clientY - rect.top);
  };
  const handleMouseMove = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    draw(e.clientX - rect.left, e.clientY - rect.top);
  };

  // Touch
  const handleTouchStart = (e) => {
    if (isSubmitted) return;
    const rect = canvasRef.current.getBoundingClientRect();
    const t = e.touches[0];
    startDrawing(t.clientX - rect.left, t.clientY - rect.top);
  };
  const handleTouchMove = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const t = e.touches[0];
    draw(t.clientX - rect.left, t.clientY - rect.top);
  };

  /* ═══════════════════════════════════════════
     4. CLEAR CANVAS
  ═══════════════════════════════════════════ */
  const handleClear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    setHasDrawn(false);
    onChange?.(null);
  };

  /* ═══════════════════════════════════════════
     5. SAVE SIGNATURE TO SERVER
     Called automatically when Submit is pressed
     (parent calls this via the onChange data,
      but we also expose saveSignature so the
      parent's submit handler can call it)
  ═══════════════════════════════════════════ */
  const saveSignatureToServer = async (dataUrl) => {
    try {
      const res = await fetch(dataUrl);
      const blob = await res.blob();
      const formData = new FormData();
      formData.append("digitalSignature", blob, "signature.png");
      await profileApi.saveSignature(formData);
      setUserSignature(dataUrl);
    } catch (err) {
      // silent — signature still used for this submission
      console.warn("Signature save failed:", err);
    }
  };

  /* ═══════════════════════════════════════════
     6. HANDLE "CHANGE SIGNATURE" CLICK
  ═══════════════════════════════════════════ */
  const handleChangeSignature = () => {
    setHasDrawn(false);
    setIsEditMode(true);
    onChange?.(null); // clear from parent until new one is drawn
  };

  /* ═══════════════════════════════════════════
     7. WHEN SUBMITTED — auto-save new drawing
  ═══════════════════════════════════════════ */
  useEffect(() => {
    if (!isSubmitted) return;
    if (!isEditMode) return; // was using saved signature, no need to save again
    if (!hasDrawn) return;   // nothing drawn

    const dataUrl = canvasRef.current?.toDataURL("image/png");
    if (dataUrl) {
      saveSignatureToServer(dataUrl);
      setIsEditMode(false);
    }
  }, [isSubmitted]);

  /* ═══════════════════════════════════════════
     RENDER
  ═══════════════════════════════════════════ */

  // Loading
  if (loading) {
    return (
      <div className="ds-wrapper">
        <p className="ds-label">Digital Signature</p>
        <div className="ds-loading-box">
          <span className="ds-loading-dot" />
          Loading your signature...
        </div>
      </div>
    );
  }

  // ── PREVIEW MODE (has saved signature, not editing) ──
  if (userSignature && !isEditMode) {
    return (
      <div className="ds-wrapper">
        <p className="ds-label">Digital Signature</p>

        <div className="ds-preview-box">
          <img src={userSignature} alt="Your signature" className="ds-preview-img"/>
        </div>

        {!isSubmitted && (
          <div style={{ textAlign: "right", marginTop: "6px" }}>
            <span className="ds-change-link" onClick={handleChangeSignature}>
              Change Signature
            </span>
          </div>
        )}
      </div>
    );
  }

  // ── DRAW MODE (first time or changing signature) ──
  return (
    <div className="ds-wrapper">
      <p className="ds-label">
        Digital Signature
        {!userSignature && (
          <span className="ds-required-tag"> * required</span>
        )}
      </p>

      <div className="ds-hint-text">
        {userSignature
          ? "Draw your new signature below"
          : "Please draw your signature below — it will be saved automatically when you submit"}
      </div>

      {/* Canvas */}
      <div style={{ position: "relative" }}>
        <canvas
          ref={canvasRef}
          style={{
            cursor: isSubmitted ? "not-allowed" : "crosshair",
            opacity: isSubmitted ? 0.6 : 1,
          }}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={stopDrawing}
          onMouseLeave={stopDrawing}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={stopDrawing}
        />

        {/* Placeholder */}
        {!hasDrawn && (
          <div className="ds-placeholder">✍ Sign here</div>
        )}

        {/* Clear icon */}
        {hasDrawn && !isSubmitted && (
          <div className="ds-clear-icon" onClick={handleClear} title="Clear">
            <Icon icon="mdi:trash-can" style={{ color: "#e53935", fontSize: "20px" }} />
          </div>
        )}
      </div>

      {/* Cancel — only if user already has a saved signature */}
      {userSignature && !isSubmitted && (
        <div style={{ textAlign: "right", marginTop: "8px" }}>
        <span
            className="ds-cancel-link"
            onClick={() => {
                setIsEditMode(false);
                onChange?.(userSignature);
            }}
            >
            Cancel
        </span>
        </div>
      )}
    </div>
  );
}

export default DigitalSignature;

